{
  "contacts": {
    "all_contacts": "All Contacts",
    "all_employees": "All Employees",
    "company_type": "Company type",
    "consent_status": "Consent status",
    "consent": {
      "management": "Consent Management",
      "edit_consent": "Edit Consent",
      "how_was_given": "How was consent given?",
      "when_was_given": "When was consent given?",
      "how_was_given_display": "How was consent given",
      "when_was_given_display": "When was consent given"
    },
    "results": "Results",
    "empty_state": "There's no contact to show here",
    "personal_contact_indicator": "-",
    "tabs": {
      "current": "Current Contacts",
      "previous": "Previous Contacts",
      "who_knows": "Who Knows",
      "connections": "Connections"
    },
    "table": {
      "contact": "Contact",
      "interaction": "Interaction",
      "last_interaction": "Last Interaction",
      "current_company": "Current Company",
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "location": "Location",
        "tags": "Tags",
        "last_interaction_total": "Last Interaction (Total)"
      }
    },
    "actions": {
      "add_to_list": "Add to List",
      "log_new_activity": "Log New Activity",
      "export_selected": "Export Selected",
      "clear_selection": "Clear selection",
      "add_tags": "Add Tags"
    },
    "order_by": {
      "label": "Order by",
      "company_name_asc": "company name asc",
      "company_name_desc": "company name desc",
      "created_at_asc": "created at asc",
      "created_at_desc": "created at desc",
      "first_name_asc": "first name asc",
      "first_name_desc": "first name desc",
      "last_interaction_asc": "last interaction asc",
      "last_interaction_desc": "last interaction desc",
      "last_name_asc": "last name asc",
      "last_name_desc": "last name desc",
      "number_of_interactions_asc": "number of interaction asc",
      "number_of_interactions_desc": "number of interaction desc",
      "contact_created_at_desc": "contact created at desc",
      "last_interaction_at_asc": "last interaction at asc",
      "last_interaction_at_desc": "last interaction at desc",
      "archived_at_asc": "archived at asc",
      "archived_at_desc": "archived at desc"
    },
    "selection": {
      "all_selected": "All {{count}} contacts selected",
      "page_selected": "All {{count}} contacts on this page are selected.",
      "select_all": "Select all {{count}} contacts",
      "modal": {
        "header": "Contacts Selected ({{count}})",
        "link_text": "{{count}} selected"
      },
      "limit": {
        "exceeded": "You've reached the {{limit}} contact selection limit.",
        "tooltip": "Contact selection limit has been reached",
        "tooltip_will_be_reached": "Contact selection limit has been reached or will be reached"
      },
      "accessibility": {
        "select_contact": "select {{email}}",
        "select_all": "select all"
      }
    },
    "errors": {
      "add_to_list": "Error adding contacts to list"
    },
    "accessibility": {
      "private_contact": "Is private contact",
      "view_hierarchy": "view contact hierarchy"
    },
    "slide": {
      "tabs": {
        "details": "Contact Details",
        "connections": "Who Knows",
        "activities": "Activity Feed",
        "notes": "Notes",
        "tasks": "Tasks",
        "marketing_settings": "Marketing Settings",
        "engagement": "Engagement",
        "opportunities": "Opportunities",
        "list_fields": "List Fields"
      },
      "loading": {
        "list_fields": "Loading list fields..."
      },
      "details": {
        "labels": {
          "email": "Email",
          "job_title": "Job Title",
          "contact_location": "Contact Location",
          "contact_office_address": "Contact Office Address",
          "contact_numbers": "Contact Numbers",
          "twitter_url": "Twitter URL",
          "linkedin_url": "LinkedIn URL",
          "education": "Education",
          "tags": "Tags",
          "company": "Company",
          "primary_location": "Primary Location",
          "company_primary_location": "Company Primary Location",
          "industries": "Industries",
          "internal_industries": "Internal Industries"
        },
        "tooltips": {
          "contact_office_address": "The main office location for this specific contact"
        },
        "placeholders": {
          "no_data": "--",
          "not_available": "N/A"
        }
      },
      "notes": {
        "empty_state": "There's no note on this contact yet"
      },
      "profile": {
        "sections": {
          "basic_information": "Basic Information",
          "company_information": "Company Information",
          "custom_fields": "Custom Fields",
          "tags": "Tags",
          "list_memberships": "List memberships",
          "other_accounts": "Other Accounts"
        },
        "labels": {
          "contact_office_location": "Contact Office Location",
          "emails": "Emails",
          "phone_numbers": "Phone Numbers",
          "primary": "Primary",
          "last_interaction": "Last Interaction",
          "added_by": "Added By"
        },
        "actions": {
          "edit_details": "Edit details",
          "update_contact": "Update Contact",
          "edit_contact": "Edit Contact",
          "move_in_hierarchy": "Move in Hierarchy",
          "unarchive": "Unarchive",
          "audit_trail": "Audit Trail",
          "create": "Create",
          "task": "Task",
          "note": "Note",
          "opportunity": "Opportunity",
          "add_to_list": "Add to List",
          "log_new_activity": "Log New Activity",
          "actions": "Actions",
          "add_to_my_contact": "Add to My Contact",
          "remove_from_my_contact": "Remove from My Contact",
          "report_incorrect_info": "Report Incorrect Info",
          "mark_company_changed": "Mark as \"Company Changed\"",
          "archive_contact": "Archive contact",
          "create_opportunity": "Create Opportunity",
          "add_contact_to_list": "Add Contact to List",
          "sync_contact_with_outlook": "Sync contact with Outlook",
          "ignore": "Ignore",
          "update_current_company": "Update Current Company",
          "link_another_contact": "Link Another Contact",
          "link": "Link",
          "more_actions": "More Actions"
        },
        "tooltips": {
          "add_to_my_contact": "Add to My Contact",
          "create_task": "Create Task",
          "create_note": "Create Note",
          "copy_email_to_clipboard": "Copy email to clipboard",
          "copy_phone_number_to_clipboard": "Copy phone number to clipboard",
          "remove_bounced_status": "Remove Bounced Status",
          "more_actions": "More actions"
        },
        "accessibility": {
          "primary_email_indicator": "Primary email indicator for {{email}}",
          "update_basic_information": "update basic information",
          "update_contact_office_location": "update contact office location",
          "add_new_email": "add new email",
          "add_new_phone_number": "add new phone number",
          "update_custom_fields": "update custom fields",
          "add_to_membership_list": "add to membership list",
          "contact_actions": "contact actions",
          "unarchive_contact": "Unarchive {{contactName}}",
          "archive_contact": "Archive contact",
          "remove_bounced_status": "Remove bounced status",
          "more_actions": "More actions"
        },
        "modals": {
          "unsaved_changes": "Unsaved Changes",
          "edit_contact": "Edit Contact",
          "link_contact": "Link Contact",
          "company_change": {
            "question": "How would you like to update the current company?",
            "helper_text": "Select option to update the current company",
            "options": {
              "add_new_work_email": "Add New Work Email",
              "add_new_company": "Add New Company",
              "add_personal_email": "Add Personal Email",
              "no_details": "I don't have any details"
            },
            "helper_text_no_details": "We will show that the contact has changed job to other users. You will be able to add the new company to this contact later. We will not archive the contact",
            "form": {
              "labels": {
                "new_work_email": "New Work Email",
                "company_name": "Company Name",
                "linkedin_url": "LinkedIn URL",
                "personal_email": "Personal Email"
              },
              "tooltips": {
                "new_work_email": "Please add work email from the new company. Email must be from a different domain. To add another email from the same domain - use Update Email option",
                "company_name": "Please add the New Company for the contact. Search for existing companies or create a new company if record does not exist",
                "linkedin_url": "Please add the LinkedIn profile URL for the contact. It is ok if the LinkedIn profile is not updated with the new position.",
                "personal_email": "Please add the Personal Email for the contact."
              },
              "placeholders": {
                "new_work_email": "Type the new work email",
                "company_name": "Select or type company",
                "linkedin_url": "Type linkedIn URL",
                "personal_email": "Type personal email"
              },
              "checkboxes": {
                "remove_from_lists": "Remove from all marketing lists.",
                "archive_previous": "Archive previous contact"
              }
            }
          },
          "update_current_company": "Update Current Company"
        },
        "status": {
          "last_interaction": "Last Interaction",
          "company_changed": "This contact has changed company. Please update.",
          "email_bounced": "Email {{emails}} of this contact recently bounced. Please update.",
          "company_changed_and_email_bounced": "This contact has changed company. Email {{emails}} of this contact recently bounced. Please update.",
          "new_company_unknown": "New Company Unknown",
          "new_company_unknown_with_description": "New Company Unknown. Click more options to update the company",
          "archived": "Archived",
          "bounced": "Bounced",
          "unengaged": "Unengaged",
          "changed_company": "Changed Company",
          "company_changed_success": "This contact is now marked as \"Company Changed\"",
          "company_changed_description": "We will show that the contact has changed company to other users. If you have a new contact details for this Person, consider adding it now."
        },
        "status_tooltips": {
          "unengaged": "Contacts who have not had any interaction or touch point with your organization for over a year.",
          "new_company_unknown": "Company shown is previous company of the contact."
        },
        "confirmations": {
          "ignore_warning_title": "Ignore Warning?",
          "ignore_warning_content": "To proceed, please confirm that the contact has not changed their company.",
          "archive_title": "Are you sure you want to archive this Contact?",
          "archive_content": "This Contact will no longer be visible in search. If this is the only contact, this person will also be archived and no longer visible in search.",
          "archive_until_next_interaction": "Archive until next interaction",
          "learn_more_about_interactions": "Learn more about interactions",
          "here": "here",
          "archive_success_title": "You've successfully archived the Contact",
          "archive_success_description": "This Contact will no longer appear in search. If it's the only contact linked to this Person, archiving may affect how the Person is displayed in Nexl. If you have a new contact for this Person, consider adding it now.",
          "add_new_contact_link": "I want to add a new contact",
          "unsaved_changes_message": "You have unsaved changes. Are you sure you want to continue without saving?",
          "link_contact_caption": "Link this contact to the current contact's company"
        },
        "tabs": {
          "basic_information": "Basic Information",
          "company": "Company"
        },
        "form": {
          "labels": {
            "job_title": "Job Title",
            "email": "Email",
            "phone_number": "Phone Number",
            "custom_fields": "Custom Fields",
            "set_as_primary": "Set as Primary",
            "first_name": "First Name",
            "last_name": "Last Name",
            "contact_location": "Contact Location",
            "address": "Address",
            "education": "Education",
            "social_media": "Social Media",
            "linkedin": "LinkedIn",
            "twitter": "Twitter",
            "linkedin_url": "LinkedIn Url",
            "twitter_url": "Twitter Url",
            "contact": "Contact"
          },
          "tooltips": {
            "email_domain": "Please use an email from the same email domain which is not a contact yet."
          },
          "messages": {
            "changes_saved": "Changes Saved!",
            "loading_contact_data": "Loading contact data",
            "form_error": "An error occurred while submitting the form.",
            "loading_linked_contacts": "Loading linked contacts"
          },
          "placeholders": {
            "type_email_or_name": "Type email or name",
            "search_address": "Search for an address",
            "education_multiple": "Education (Multiple)"
          },
          "validation": {
            "same_domain_error": "Accounts must have different domains. Use 'Basic Information' tab for email with same domain"
          }
        }
      }
    },
    "archive_person": {
      "confirm_title": "Are you sure you want to archive the Person?",
      "contacts_impacted": "These contacts will be impacted",
      "understanding_checkbox": "I understand that Archiving the Person will archive all the Contacts this Person associated with.",
      "archive_until_interaction": "Archive until next interaction",
      "archive_all_selected": "Archive All Selected"
    },
    "mark_company_changed": {
      "modal_title": "Mark as \"Company Changed\"",
      "modal_caption": "We will show that the contact has changed company to other users. Alternatively, you can archive this contact and add New Contact to this Person.",
      "add_new_contact_button": "I want to add a new contact",
      "continue": "Continue",
      "confirmation_title": "Are you sure you want to mark this contact as \"Company Changed\"?",
      "remove_from_marketing_lists": "Remove from all Marketing Lists",
      "options": {
        "mark_changed": "Mark this contact as \"Company changed\"",
        "mark_changed_helper": "We'll not archive the current contact.",
        "archive_contact": "Archive this contact",
        "archive_contact_helper": "We'll archive this contact. You can also add new Contact."
      }
    },
    "add_new_contact": {
      "continue": "Continue",
      "add_new_contact": "Add new contact",
      "success": "You've successfully created a new contact",
      "first_step_header": "Add new Contact to the person",
      "first_step_header_description": "Add a New Company Email or Personal Email to the Person and we'll create a new Contact based on that.",
      "email_already_exist_in_this_person": "This email already exist in this Person's records. Check archived contacts if you don't see it.",
      "email_already_exist_in_another_person": "This email already exist in another Person's records. Check archived contacts if you don't see it.",
      "i_dont_have_email_for_this_contact": "I don't have email for this contact",
      "this_person_already_has_a_contact_with_this_company": "This Person already has a contact with this company.",
      "company_name": "Company Name",
      "switch_back_to_email": "Switch back to Email",
      "email": "Email",
      "job_title": "Job Title",
      "add_company_contact": "Add Company Contact",
      "we_detected_this_email_is_a_company_email": "We've detected this email is a company email. Please review details",
      "there_was_an_error_validating_the_email": "There was an error validating the email",
      "please_use_a_valid_email_address": "Please use a valid email address",
      "are_you_sure_you_want_to_consolidate_these_persons_into_single_person_profile": "Are you sure you want to consolidate these Persons into single Person profile?",
      "personal_details": "Personal details",
      "contacts": "Contacts",
      "review_potential_duplicates_of_the_person": "Review potential duplicates of the Person",
      "we_detected_potential_person_duplicate_for_the_email_you_want_to_add": "We've detected Potential Person Duplicate for the email you want to add. You can flag them for admin review.",
      "potential_duplicates_have_been_flagged_for_review": "Potential Duplicates have been flagged for review",
      "thanks_for_helping_keep_our_data_clean": "Thanks for helping keep our data clean! Admin users will review and take action to manage these records.",
      "start_consolidating": "Start consolidating",
      "flag_as_duplicates": "Flag as duplicates",
      "move_email": "Move email?",
      "we_might_have_misplaced_the_email": "These persons aren't duplicates, so we might have misplaced the email. Should we move it to the current profile?",
      "visit_profile": "Visit Profile",
      "these_are_not_duplicates": "These are not duplicates",
      "form": {
        "title": "Add Contact",
        "validation": {
          "email_invalid": "This is not a valid email",
          "url_invalid": "This is not a valid URL",
          "email_or_linkedin_required": "You must provide either an email or a LinkedIn URL"
        },
        "labels": {
          "linkedin_url": "LinkedIn URL"
        }
      },
      "merge": {
        "title": "Update Email",
        "button_text": "Update Contact Email",
        "validation": {
          "contact_required": "Contact is required"
        },
        "labels": {
          "contact": "Contact",
          "placeholder": "What is the active email of this contact?"
        },
        "actions": {
          "set_email": "Set Email"
        }
      }
    },
    "archived": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Company",
          "last_interaction": "Last Interaction",
          "archived_at": "Archived At",
          "action": "Action"
        }
      },
      "unarchive_on_next_interaction": "This contact will be automatically unarchived on next interaction",
      "changed_company": "Changed Company",
      "actions": {
        "archive_contact": {
          "confirm_title": "Archive Contact?",
          "confirm_content": "Please confirm to archive contact.",
          "bulk_confirm_title_single": "Archive Contact?",
          "bulk_confirm_title_multiple": "Archive Contacts?",
          "bulk_confirm_content_single": "Please confirm to archive contact.",
          "bulk_confirm_content_multiple": "Please confirm to archive contacts.",
          "automatically_unarchive": "Automatically unarchive on next interaction",
          "learn_more_interactions": "Learn more about interactions",
          "here": "here"
        },
        "unarchive_contact": {
          "confirm_title": "Unarchive contact?",
          "confirm_content": "Please confirm to unarchive contact.",
          "bulk_confirm_title": "Unarchive contacts?",
          "bulk_confirm_content": "Please confirm to unarchive contacts.",
          "label": "bulk unarchive"
        },
        "purge_contact": {
          "modal_header": "Purge Contact",
          "modal_caption": "Permanently remove the contact information, email addresses, audit trail, marketing lists, who knows, notes and tasks.",
          "warning_message": "Once you proceed, this action cannot be reversed.",
          "reason_label": "Reason",
          "reason_placeholder": "Type reason for purging"
        }
      },
      "order_by": {
        "label": "Order by"
      }
    },
    "tags": {
      "add_tags": "Add Tags",
      "tags": "Tags"
    },
    "email": {
      "remove_email": "remove email {{email}}",
      "remove_title": "Remove {{email}}",
      "remove_confirmation": "Are you sure you want to remove {{email}}?"
    },
    "location": {
      "contact_location": "Contact Location"
    },
    "report_incorrect_info": {
      "report_incorrect_info": "Report Incorrect Info",
      "modal_header": "Report Incorrect Contact Info",
      "incorrect_fields": "Incorrect Fields",
      "comments": "Comments",
      "report": "Report",
      "fields": {
        "name": "Name",
        "job_title": "Job Title",
        "location": "Location",
        "phone_numbers": "Phone Numbers",
        "twitter_url": "Twitter Url",
        "linkedin_url": "Linkedin Url",
        "education": "Education"
      }
    },
    "preferences": {
      "preference_management": "Preference Management",
      "no_preferences_set": "It looks like you haven't set any preferences for this contact yet.",
      "add_preference": "Add Preference",
      "no_preferences_schema": "It looks like you haven't set any preferences yet.",
      "edit_contact_preferences": "Edit Contact Preferences",
      "edit_preference": "Edit Preference"
    },
    "incomplete": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Company",
          "last_interaction_total": "Last Interaction (Total)",
          "created_at": "Created At",
          "missing_info": "Missing Info",
          "actions": "Actions",
          "contact_office_location": "Contact Office Location"
        }
      },
      "actions": {
        "ignore_contact": "ignore contact",
        "edit_contact": "edit contact",
        "bulk_ignore": "bulk ignore",
        "bulk_archive": "bulk archive",
        "export_contacts": "Export Contacts"
      },
      "forms": {
        "labels": {
          "first_name": "First Name",
          "last_name": "Last Name",
          "job_title": "Job Title",
          "street_address": "Street Address",
          "city": "City",
          "state": "State",
          "postcode": "Postcode",
          "contact_location": "Contact Location",
          "company_location": "Company Location",
          "office_location": "Office Location",
          "contact_office_address": "Contact Office Address"
        },
        "placeholders": {
          "search_address": "Search for an address"
        }
      },
      "status": {
        "loading_contact_data": "Loading contact data",
        "selected": "Selected"
      },
      "modals": {
        "edit": "Edit",
        "update_contact_data": "Update Contact Data",
        "bulk_edit": "Bulk Edit",
        "incomplete_update_contact": "Incomplete Update Contact"
      },
      "grid": {
        "all_incomplete": "All Incomplete",
        "rows_per_page": "Rows Per Page",
        "editable": "Editable"
      },
      "order_by": {
        "label": "Order by",
        "sort_by": "Sort by"
      }
    },
    "export": {
      "export_contacts": "Export Contacts"
    },
    "switch_contact": {
      "switch_button": "Switch",
      "switch_tooltip": "This contact has multiple email addresses. Click to switch between them.",
      "switch_account_modal": "Switch Account"
    },
    "who_knows": {
      "categories": {
        "our_firm": "Our firm",
        "colleagues": "Colleagues",
        "third_party": "Third party"
      },
      "empty_state": "Looks like no one knows this contact :(",
      "load_more_current": "These are all the people who know this contact.",
      "also_known_by": "Also Known by",
      "load_more_previous": "These are all the people who previously knew this contact.",
      "through_job": "through {{job}}"
    },
    "duplicate": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Company",
          "who_knows": "Who Knows",
          "last_interaction": "Last Interaction",
          "same_person_question": "Is this the same person?"
        }
      },
      "actions": {
        "yes": "Yes",
        "no": "No"
      },
      "merge": {
        "modal_title_same_company": "Please select the correct contact details. ",
        "modal_title_different_company": "Please select contact that is still active",
        "description_with_email": "We will combine both contact's email addresses, list memberships, activity feed and notes.",
        "description_without_email": "We will combine both contact's list memberships, activity feed and notes.",
        "archive_warning": "The unselected contact's remaining details and account will be archived.",
        "both_accounts_active": "Both accounts are still active"
      },
      "keep_both": {
        "confirm_title": "Confirm to keep both contacts",
        "confirm_content": "This action will permanently remove the contacts from this list.",
        "label": "contacts active"
      },
      "order_by": "Order by"
    },
    "company_contacts": {
      "empty_state": {
        "title": "No Contacts Yet",
        "description": "This company doesn't have any contacts yet. Add a new contact to get started."
      },
      "table": {
        "headers": {
          "contact": "Contact",
          "email": "Email",
          "location": "Location",
          "tags": "Tags",
          "interactions_count": "# of Interactions",
          "last_interaction": "Last Interaction"
        }
      },
      "actions": {
        "stay_in_touch": "Stay In Touch",
        "add_tags": "Add Tags",
        "move_contacts_in_hierarchy": "Move Contacts in Hierarchy",
        "all_contacts_selected": "All {{count}} contacts selected"
      },
      "sync": {
        "labels": {
          "first_name": "First Name",
          "last_name": "Last Name",
          "emails": "Email(s)",
          "business_phone": "Business Phone",
          "job_title": "Job Title",
          "business_address": "Business Address",
          "company_name": "Company Name",
          "office_location": "Office Location",
          "company_numbers": "Company Numbers"
        },
        "dialog": {
          "title": "Do you want to sync this contact to outlook?",
          "description": "Following data of this contact will be synced to Outlook. This Contact is missing a first name. Please add a first name to sync this contact.",
          "description_with_emails": "Following data of this contact will be synced to Outlook.\n    Emails and Phone numbers will be added to existing emails and phone numbers\n     if they do exist. Other information will replace current information."
        },
        "result": {
          "success_title": "Outlook Contact Synced",
          "success_description": "Please check your Outlook contact for updated info",
          "error_title": "Contact Sync Failed",
          "error_description": "Oops! Something went wrong while syncing the contact. Please try again later."
        }
      },
      "messages": {
        "move_request_received": "We have received your request to move contact(s). This usually takes 20-30 seconds to process."
      }
    }
  },
  "prospects": {
    "title": "Expand Client Relationships / Prospecting",
    "search": {
      "name": "Name",
      "job_title": "Job Title",
      "location": "Location"
    },
    "table": {
      "prospect": "Prospect",
      "location": "Location",
      "email": "Email",
      "action": "Action"
    },
    "banner": "We do our best to keep the results as up to date as possible, but you might find contacts who have already joined a new company. Please check the contact's LinkedIn profile for the most recent information. Not all email addresses provided can be verified. Therefore, we cannot guarantee the accuracy of the contact details provided. Do not use prospects in your automated email campaigns.",
    "status": {
      "searching": "Searching",
      "still_searching": "Still searching",
      "view_contact": "View Contact",
      "no_contact_details": "We have not found any contact details yet. Please check again in 30 minutes."
    }
  },
  "insights": {
    "stats": {
      "activity_past_90_days": "Activity Past 90 Days",
      "updated": "Updated {{timeAgo}}",
      "interactions": "Interactions",
      "emails": "Emails",
      "meetings": "Meetings"
    },
    "engagement": {
      "over_time": "Engagement Over Time"
    },
    "contacts": {
      "most_active": "Most Active Contacts"
    },
    "opportunities": {
      "opportunity": "Opportunity",
      "referrals": "Referrals",
      "success_rate": "Success rate",
      "total_open": "Total open opportunities ({{count}})",
      "total_won": "Total won opportunities ({{count}})",
      "total_open_referred": "Total open referred opportunities ({{count}})",
      "total_referred_won": "Total referred opportunities won ({{count}})",
      "amount_in": "Amount in {{currency}}"
    },
    "departments": {
      "engagement_by_practice": "Engagement by practice group",
      "practice_group": "Practice Group",
      "interactions": "Interactions"
    }
  },
  "reporting": {
    "iframe_title": "company reporting (PowerBI)"
  },
  "tabs": {
    "directory": "DIRECTORY",
    "notes": "Notes",
    "create_task": "Create Task",
    "loading_notes": "Loading notes...",
    "aria_labels": {
      "active_opportunities": "active opportunities",
      "open_tasks": "open tasks"
    },
    "additional": {
      "name_taken": "Name is already taken"
    }
  },
  "companies": {
    "all_companies": "All Companies",
    "incomplete": {
      "table": {
        "headers": {
          "company": "Company",
          "last_interaction_total": "Last Interaction (Total)",
          "created_at": "Created At",
          "type": "Type",
          "missing_info": "Missing Info",
          "actions": "Actions"
        }
      },
      "actions": {
        "update_company": "Update Company",
        "ignore_company": "ignore company",
        "edit_company": "edit company",
        "export_companies": "Export Companies"
      },
      "bulk_actions": {
        "ignore": "Ignore",
        "archive": "Archive"
      },
      "order_by": "Order by",
      "update": {
        "modal_title": "Update Company Data",
        "loading": "Loading company",
        "form": {
          "type": "Type",
          "industries": "Industries",
          "street_address": "Street Address",
          "city": "City",
          "state": "State",
          "postcode": "Postcode",
          "set_primary_location": "Set as Primary Location"
        }
      }
    },
    "duplicate": {
      "table": {
        "headers": {
          "company": "Company",
          "type": "Type",
          "contacts": "Contacts",
          "last_interaction": "Last Interaction",
          "action": "Action"
        }
      },
      "actions": {
        "merge": "Merge",
        "keep_both": "Keep Both",
        "continue": "Continue"
      },
      "merge": {
        "modal_title": "Merge Company",
        "manual_modal_title": "Manual Merge",
        "description": "We will combine both companies' contacts and interactions. The unselected company's notes, tasks, and documents will be permanently removed.",
        "manual_description": "We will combine both companies' contacts and interactions. Any notes, tasks, and documents other than those of the main company will be permanently deleted.",
        "warning": "Merged companies can't be undone. Please make sure you select the right company.",
        "select_main_company": "Please select the company as the main contact:",
        "main_company": "Main Company",
        "company_to_merge": "Company to be merged",
        "type_to_confirm": "Type \"{{label}}\" to confirm",
        "placeholder_merge": "Type to search main company",
        "placeholder_to_merge": "Type to search company to be merged",
        "merged_result_preview": "Merged Result Preview",
        "placeholder_confirm": "Type \"Merge\" to confirm",
        "continue": "Continue"
      },
      "keep_both": {
        "button": "Keep Both!",
        "confirm_title": "Do you want to add these companies to the same hierarchy?",
        "confirm_content": "By adding them as hierarchy you connect them as a group.",
        "yes": "Yes",
        "no_separate": "No, keep it separate"
      },
      "order_by": "Order by"
    },
    "table": {
      "empty_message": "There are no companies to display here",
      "headers": {
        "company": "Company",
        "location": "Location",
        "contacts": "Contacts",
        "type": "Type",
        "engagement": "Engagement",
        "last_interaction": "Last Interaction",
        "last_interaction_total": "Last Interaction (Total)",
        "contact": "Contact",
        "interactions_count": "# of interactions",
        "past_role_at": "Past role at",
        "year_left": "Year left"
      },
      "actions": {
        "export_selected": "Export Selected",
        "download_export": "Download export",
        "clear_selection": "Clear selection"
      },
      "row_aria_label": "company row"
    },
    "slide": {
      "tabs": {
        "list_fields": "List Fields",
        "contacts": "Contacts",
        "who_knows": "Who Knows",
        "tasks": "Tasks",
        "opportunities": "Opportunities",
        "documents": "Documents",
        "notes": "Notes"
      },
      "info": {
        "type": "Type",
        "contacts": "Contacts",
        "last_meeting": "Last Meeting",
        "last_interaction": "Last Interaction",
        "internal_owner": "Internal owner",
        "status": "Status",
        "estimated_fee": "Estimated Fee"
      }
    },
    "form": {
      "create_company": "Create Company",
      "update_company": "Update Company",
      "company_domain": "Company Domain",
      "company_name": "Company Name",
      "type": "Type",
      "internal_industries": "Internal Industries",
      "industries": "Industries",
      "client_id": "Client ID",
      "group_id": "Group ID",
      "description": "Description",
      "phone_numbers": "Phone Numbers",
      "company_emails": "Company Emails",
      "linkedin": "LinkedIn",
      "twitter": "Twitter",
      "website": "Website",
      "number_of_employees": "Number of Employees",
      "validation": {
        "company_domain_required": "Company domain is required",
        "valid_domain": "Please enter a valid domain"
      }
    },
    "export": {
      "export_companies": "Export Companies"
    },
    "connections": {
      "description": "People in your contact who have prior experience in this company"
    },
    "opportunities": {
      "loading": "Loading opportunities",
      "search_placeholder": "Search",
      "status_all": "All",
      "date_label": "Date",
      "opportunity_number": "Opportunity #",
      "open_opportunity_slide": "Open opportunity slide",
      "total_opportunity_value": "Total Opportunity Value:",
      "not_accessible": "Not accessible",
      "not_accessible_tooltip": "Total value is not accessible as some opportunity details are private.",
      "no_access_message": "You don't have access to this opportunity."
    },
    "autocomplete": {
      "no_options": "start typing to search for companies"
    },
    "avatar": {
      "blocked": "Blocked"
    },
    "actions": {
      "remove_key_contact": "remove key contact",
      "confirm_remove_title": "Are you sure?",
      "confirm_remove_content": "Confirm you would like to remove this key contact."
    },
    "status": {
      "loading_notes": "Loading Notes..."
    },
    "latest_activities": {
      "title": "Latest BD and Marketing Activities",
      "last_bd_activity": "Last BD Activity",
      "last_marketing_activity": "Last Marketing Activity",
      "log_new_activity": "Log new activity",
      "loading_timeline": "Retrieving your key activity timeline",
      "empty_state_alt": "No business development or marketing activities found"
    },
    "industry_update": {
      "add_industry": "[Add Industry]",
      "industries_label": "Industries"
    },
    "blocking": {
      "block_title": "Block company?",
      "block_content": "This action will remove all interactions for the company and make sure no new ones are recorded",
      "block_button": "Block",
      "block_aria_label": "block company",
      "unblock_title": "Unblock company?",
      "unblock_content": "Please confirm to unblock company",
      "unblock_button": "UnBlock"
    },
    "meetings": {
      "last_meeting_title": "Last Meeting",
      "no_meeting_title": "You haven't had a meeting with this company yet.",
      "no_meeting_description": "Reach out to start building a relationship with them."
    },
    "relationship_partners": {
      "title": "Relationship Partners",
      "last_interaction_label": "Last Interaction",
      "none_value": "None",
      "no_partners_title": "No relationship partner added.",
      "no_partners_description": "Add relationship partners who are responsible for maintaining this relationship."
    },
    "key_contacts": {
      "add_title": "Add Key Contact",
      "add_aria_label": "Add key contact",
      "label": "Key Contact",
      "validation": {
        "required": "Please select a key contact"
      },
      "title": "Key Contacts",
      "no_contacts_title": "No key contacts added.",
      "no_contacts_description": "Add key contacts to help you focus on relationships that matter most.",
      "last_meeting": "Last Meeting",
      "last_interaction": "Last Interaction",
      "none": "None"
    },
    "ignore": {
      "title": "Ignore Company?",
      "content": "This action will permanently remove the company from this list.",
      "label": "ignore"
    },
    "bulk_ignore": {
      "title": "Bulk Ignore Companies",
      "content": "This action will permanently remove the companies from this list"
    },
    "company_type": {
      "update_title": "Update Company Type",
      "update_link": "Update Company Type",
      "label": "Company Type"
    },
    "order_by": {
      "label": "Order by",
      "company_name_asc": "company name asc",
      "company_name_desc": "company name desc",
      "created_at_asc": "created at asc",
      "created_at_desc": "created at desc",
      "last_interaction_asc": "last interaction asc",
      "last_interaction_desc": "last interaction desc",
      "interactions_90_days_asc": "interactions last 90 days asc",
      "interactions_90_days_desc": "interactions last 90 days desc",
      "number_of_interactions_asc": "number of interactions asc",
      "number_of_interactions_desc": "number of interactions desc",
      "archived_at_asc": "archived at asc",
      "archived_at_desc": "archived at desc"
    },
    "logo": {
      "update_title": "Update Company Logo",
      "update_caption": "The company logo or image will be cropped to fit the frame. Default logo will be displayed if left blank.",
      "remove_title": "Are you sure you want to remove the company logo?",
      "remove_button": "Remove Logo",
      "upload_placeholder": "Drag a file here or click to upload\n(max file size: 100 KB. Use a PNG or JPEG format with 1:1 ratio).",
      "upload_validation": "Please upload an image",
      "alt_text": "{{companyName}} logo"
    },
    "contact_count": {
      "aria_label": "There're {{count}} contacts in this company"
    },
    "relationship_partner": {
      "add_title": "Add Relationship Partner",
      "add_aria_label": "Update relationship partner",
      "label": "Relationship Partner",
      "validation": {
        "required": "Please add a partner"
      }
    },
    "archive": {
      "confirm_title": "Please confirm to archive this company",
      "confirm_content": "Are you sure you want to archive this company",
      "bulk_confirm_title": "Bulk Archive companies",
      "bulk_confirm_content": "Please confirm to archive these companies",
      "bulk_label": "bulk restore",
      "unarchive_confirm_title": "Unarchive company?",
      "unarchive_confirm_content": "Please confirm to unarchive company",
      "unarchive_aria_label": "unarchive",
      "unarchive_title": "unarchive",
      "bulk_unarchive_confirm_title": "Bulk unarchive companies?",
      "bulk_unarchive_confirm_content": "Please confirm to unarchive these companies",
      "bulk_unarchive_label": "bulk unarchive"
    },
    "office_locations": {
      "labels": {
        "field_label": "Labels",
        "primary": "Primary",
        "headquarters": "Headquarters",
        "placeholder": "Office Location Labels"
      },
      "tooltips": {
        "primary_info": "The primary office location used for communication and records.",
        "headquarters_info": "The official address of the company's headquarters."
      },
      "actions": {
        "add_location": "Add Location",
        "update_office_location": "update office location"
      },
      "modals": {
        "company_locations": "Company Locations",
        "company_address": "Company Address",
        "add_location": "Add Location",
        "edit_address": "Edit Address",
        "update_company_address": "Update Company Address"
      },
      "empty_state": {
        "no_locations_title": "No office locations added yet",
        "no_locations_description": "Start by adding a new address",
        "no_location_yet": "This company doesn't have any location yet, add one now"
      },
      "confirmations": {
        "update_warning": "By updating this company address, the contact's office address linked to it will also be updated. This cannot be reversed.",
        "delete_restriction": "You can't delete the headquarters or primary office location."
      },
      "chips": {
        "more_label": "+{{count}} more"
      },
      "accessibility": {
        "office_location_actions": "office location actions",
        "primary_label_info": "primary label info",
        "headquarter_label_info": "headquarter label info"
      },
      "validation": {
        "please_choose_country": "Please choose a country",
        "please_search_address": "Please search for an address"
      }
    },
    "archived": {
      "table": {
        "headers": {
          "company": "Company",
          "country": "Country",
          "type": "Type",
          "interactions": "Interactions",
          "last_interaction": "Last Interaction",
          "archived_at": "Archived At"
        }
      },
      "actions": {
        "unblock_company": "unblock company",
        "block_company": "block company",
        "bulk_unarchive": "bulk unarchive"
      },
      "order_by": "Order by"
    },
    "engagement_overview": {
      "key_numbers": {
        "open_tasks_plural": "open tasks",
        "open_tasks_singular": "open task",
        "upcoming_meetings_plural": "upcoming meetings scheduled",
        "upcoming_meetings_singular": "upcoming meeting scheduled",
        "open_opportunities_plural": "open opportunities",
        "open_opportunities_singular": "open opportunity",
        "tooltip_pattern": "You have {{count}} {{label}}",
        "visit_label": "visit {{label}}"
      }
    },
    "documents": {
      "actions": {
        "add_document": "add document",
        "edit_document": "edit company document",
        "remove_document": "remove company document",
        "document_button": "Document"
      },
      "removal": {
        "confirm_title": "Are you sure you want to delete this document?"
      }
    },
    "who_knows": {
      "no_contacts_title": "No Contacts",
      "no_contacts_description": "No one from your company has contacted this organization."
    },
    "report_incorrect_info": {
      "report_incorrect_info": "Report Incorrect Info",
      "modal_header": "Report Incorrect Company Info",
      "incorrect_fields": "Incorrect Fields",
      "comments": "Comments",
      "report": "Report",
      "fields": {
        "name": "Name",
        "logo": "Logo",
        "location": "Location",
        "phone_numbers": "Phone numbers",
        "domain": "Domain",
        "industry": "Industry"
      }
    }
  },
  "key_activity": {
    "slide": {
      "aria_label": "key activity slide",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "note": "Note",
      "comments": "Comments"
    },
    "performance": {
      "current": "Current",
      "best": "Best",
      "consecutive": "Consecutive",
      "longest": "Longest",
      "weeks": "Weeks",
      "current_tooltip": "You have logged {{count}} key activities this month",
      "best_tooltip": "Your personal best: {{count}} key activities in a month",
      "consecutive_tooltip": "You've logged weekly key activities for the past {{count}} weeks",
      "longest_tooltip": "Your longest streak: {{count}} weeks"
    },
    "firm_wide": {
      "title": "Firm Wide",
      "this_month": "This Month",
      "tooltip": "Total key activities across the firm this month"
    },
    "grid": {
      "loading_aria_label": "loading key activities",
      "load_limit_message": "There are more key activities than shown.",
      "show_less": "show less",
      "show_more": "+{{count}} more",
      "headers": {
        "date": "Date",
        "activity": "Activity"
      }
    },
    "filters": {
      "select_employee": "Select Employee",
      "select_month_year": "select month and year",
      "select_activity_category": "select activity category",
      "all_employees": "All",
      "basic": "Basic",
      "large": "Large",
      "select_all": "Select All",
      "categories": {
        "transactional": "Transactional",
        "key_activity": "Key Activity"
      },
      "items": {
        "emails": "Emails",
        "meetings": "Meetings",
        "lead_activities": "Lead Activities",
        "bd_activities": "BD Activities",
        "marketing_activities": "Marketing Activities"
      }
    },
    "chart": {
      "business_development": "Business Development Activity",
      "lead_activity": "Lead Activity",
      "marketing_activity": "Marketing Activity"
    },
    "categories": {
      "business_development": "Business Development",
      "lead": "Lead",
      "marketing": "Marketing"
    },
    "forms": {
      "log_new_activity": "Log New Activity",
      "edit_key_activity": "Edit Key Activity",
      "delete_key_activity": "Delete Key Activity",
      "date_time_label": "Date and Time of Activity",
      "end_date_time_label": "End Date and Time",
      "type_label": "Type",
      "activity_label": "Activity",
      "contacts_involved_label": "Contacts Involved",
      "staff_involved_label": "Staff Involved",
      "notes_label": "Notes",
      "contacts_selected": "{{count}} contacts selected",
      "labels": {
        "activity": "Activity",
        "description": "Description",
        "type": "Type",
        "notes": "Notes"
      },
      "placeholders": {
        "activity": "Activity",
        "notes": "Notes",
        "activity_title": "Activity Title"
      },
      "validation": {
        "choose_activity": "Please choose an activity",
        "choose_activity_type": "Please choose activity type",
        "record_date_time": "Please record date and time",
        "choose_contact": "Please choose at least one contact",
        "end_date_after_start": "End date must be later than start date"
      }
    },
    "modals": {
      "activity_details": "Activity Details",
      "delete_activity": "Delete Activity",
      "edit_activity": "Edit Activity"
    },
    "interactions": {
      "had_meeting_with": " had a meeting with ",
      "sent_email_to": " sent an email to ",
      "with": " with ",
      "private_between_participants": "Private {{type}} between {{count}} participants",
      "from": "From: ",
      "to": "To: "
    },
    "notes": {
      "view_notes": "View notes",
      "hide_notes": "Hide notes"
    },
    "navigation": {
      "show_less": "show less",
      "show_all": "show all",
      "others": "others"
    },
    "actions": {
      "update_aria_label": "update key activity",
      "update_title": "update key activity",
      "remove_aria_label": "remove key activity",
      "remove_title": "remove key activity",
      "log_new_activity": "Log new activity",
      "remove_activity": "Remove activity",
      "edit_activity": "Edit Activity",
      "delete_activity": "Delete Activity",
      "mark_as_bd_activity": "Mark as BD Activity",
      "actions_aria_label": "{{title}} actions",
      "add_to_list": "Add to List",
      "edit": "Edit",
      "delete": "Delete",
      "save": "Save"
    },
    "category_titles": {
      "business_development": "business development activity",
      "lead": "lead activity",
      "marketing": "marketing activity",
      "unknown": "unknown activity"
    },
    "category_labels": {
      "business_development": "business development activity",
      "lead": "lead activity",
      "marketing": "marketing activity",
      "unknown": "unknown activity"
    },
    "email_directions": {
      "employee_sent": "Email sent",
      "employee_received": "Email received"
    },
    "activity_title": {
      "meeting": "Meeting",
      "email": "Email"
    },
    "removal": {
      "confirmation_title": "Are you sure?",
      "confirmation_content": "Deleting the activity will permanently delete the activity and remove from the contact activity feed, calendar and any lists the activity has been added to."
    },
    "timeline": {
      "upcoming_activities": "Upcoming Activities",
      "past_activities": "Past Activities"
    },
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "participants": {
      "private_interaction": "Private {{type}} between {{count}} participants"
    },
    "types": {
      "email": "email",
      "meeting": "Meeting",
      "email_sent": "Email sent",
      "email_received": "Email received",
      "had_meeting_with": " had a meeting with ",
      "sent_email_to": " sent an email to ",
      "with": " with "
    },
    "header": {
      "log_activity": "Log activity",
      "search_placeholder": "Search by activity title",
      "date_label": "Date",
      "filter_label": "Filter",
      "filters_active_aria": "{{count}} filters are active"
    }
  },
  "mobile_contact_request": {
    "objective_progress": {
      "thanks_for_update": "Thanks for the update :)"
    },
    "contact_request_page": {
      "thank_you_message": "Thank you for adding your contacts. You can close this window now.",
      "im_done": "I'm Done"
    },
    "header": {
      "instruction_text": "Please select and add your contacts you want to add to list \"{{listName}}\". Once you have added your contacts, click on \"I'm done\"."
    },
    "my_contacts": {
      "my_contacts": "My Contacts",
      "company_type": "Company type",
      "consent_status": "Consent status",
      "no_contacts_message": "There's no contact to show here"
    },
    "bulk_add": {
      "contact_list": "Contact List",
      "bulk_add_description": "Bulk add contacts to list",
      "adding_in_progress_message": "The contact is being added. Please refresh the page to see the updated list.",
      "adding_in_progress_title": "Adding Contact in Progress",
      "add_selected": "Add Selected"
    },
    "contacts_table": {
      "selected": "selected",
      "contact": "Contact",
      "company": "Company",
      "location": "Location",
      "last_interaction": "Last Interaction"
    }
  },
  "meetings": {
    "slide": {
      "aria_label": "meeting slide",
      "add_key_activity": "Add key activity",
      "contacts_involved": "Contacts Involved",
      "staff_involved": "Staff Involved",
      "companies": "Companies"
    },
    "upcoming": {
      "cancelled": "[Cancelled]",
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "no_meetings_coming_up": "There's no meetings coming up"
    },
    "recent": {
      "with": "With:",
      "mark_as_bd_activity": "mark as bd activity",
      "create_task": "Create Task",
      "create_note": "Create Note",
      "no_recent_meetings": "You haven't had a meeting for a while"
    },
    "calendar_view": {
      "all": "All",
      "select_all": "Select All",
      "tasks": "Tasks",
      "external_meetings": "External Meetings",
      "key_activities": "Key Activities",
      "task_tooltip": "task"
    },
    "contact_table": {
      "show_less": "Show less",
      "show_more": "Show more"
    },
    "key_activity": {
      "view_activity_details": "view activity details",
      "activity": "Activity",
      "type": "Type",
      "note": "Note",
      "edit_activity": "Edit activity",
      "remove": "Remove"
    }
  },
  "company_list": {
    "show_personal_info": "Show personal info",
    "close_personal_info": "Close personal info"
  },
  "reports": {
    "search_placeholder": "Search Report",
    "loading": "Loading Reports",
    "loading_report": "Loading report",
    "empty_state": "No Reports Available",
    "browser_not_supported": "Your browser does not support iframes."
  },
  "employee": {
    "autocomplete": {
      "no_options_text": "start typing to search for employees",
      "all_option": "All"
    },
    "engagement": {
      "relationship_partner": {
        "title": "Relationship Partner",
        "description": "All companies where this employee is a relationship partner"
      },
      "top_companies": {
        "title": "Top 10 Companies",
        "description": "Top 10 companies by number of interactions"
      },
      "top_contacts": {
        "title": "Top 10 Contacts",
        "description": "Top 10 contacts by number of interactions"
      },
      "table_headers": {
        "company": "Company",
        "opportunities": "Opportunities",
        "partners": "Partners",
        "type": "Type",
        "engagement": "Engagement",
        "industry": "Industry",
        "internal_industry": "Internal Industry",
        "contact": "Contact",
        "interactions_count": "# of Interactions",
        "who_knows": "Who Knows"
      }
    }
  },
  "hierarchy": {
    "slide": {
      "title": "Company Hierarchy",
      "loading_aria_label": "loading company hierarchy",
      "errors": {
        "cannot_move": "Cannot move company:",
        "problem_showing": "Problem showing hierarchy:"
      }
    },
    "view": {
      "dense_view": "Dense view",
      "view_hierarchy": "View Company Hierarchy",
      "companies_count": "Companies:"
    },
    "info": {
      "last_interaction": "Last interaction"
    },
    "actions": {
      "add_child_company": "add new child company under",
      "update_fields": "Update Fields",
      "update_field": "update field",
      "hide_children": "Hide child companies of",
      "show_children": "Show child companies of"
    },
    "removal": {
      "confirmation_title": "Are you sure?",
      "confirmation_content": "Click confirm to remove company from hierarchy. You can always add it back later",
      "remove_label": "Remove {{companyName}} from hierarchy"
    },
    "placement": {
      "title": "Placement",
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Company",
          "location": "Location",
          "actions": "Actions"
        },
        "changed_company": "Changed Company",
        "ignore_contact": "ignore contact",
        "add_to_hierarchy": "add to hierarchy"
      },
      "ignore": {
        "confirmation_title": "Ignore Contact?",
        "confirmation_content": "This action will permanently remove the contact from this list.",
        "label": "ignore"
      }
    },
    "contacts": {
      "move_in_hierarchy": "Move Contacts in Hierarchy",
      "move_contacts": "Move Contacts",
      "select_company": "Select company",
      "company_placeholder": "Company",
      "create_new_company": "Create new company here"
    },
    "company_creation": {
      "modal_title": "Create New Company",
      "create_link": "create new company here",
      "submit_button": "Add",
      "domain_label": "What email domain do contacts from this company use?",
      "domain_placeholder": "Email domain",
      "domain_caption": "Type the email domain contacts of this company will use. Leave blank if it uses the same as the current company.",
      "name_label": "What is the name of the company?",
      "name_placeholder": "Company name",
      "name_caption": "You can change the name of the company at any time.",
      "company_domain_label": "Company Domain",
      "company_name_label": "Company Name"
    },
    "bulk_associate": {
      "add_to_hierarchy": "Add company to hierarchy",
      "modal_title": "Add company to hierarchy",
      "select_companies": "Select companies",
      "companies_placeholder": "Companies",
      "if_not_exist": "If the company does not exist yet,"
    },
    "validation": {
      "company_required": "Company is required",
      "company_name_required": "Company name is required",
      "select_one_company": "please select at least one company",
      "enter_company_name": "please enter a company name"
    }
  },
  "updated_contacts": {
    "no_updates": {
      "title": "Nexl automatically keeps your contacts up-to-date.",
      "description": "As soon as Nexl discovers that one of your contacts has updated their LinkedIn profile, we will notify you here and keep your contacts updated. This only works for contacts with a valid LinkedIn URL."
    },
    "table": {
      "headers": {
        "previous": "Previous",
        "current": "Current",
        "date": "Date"
      }
    },
    "company_type": "Company Type"
  },
  "company_details": {
    "title": "Company Details",
    "client_id": "Client ID",
    "group_id": "Group ID",
    "internal_industries": "Internal Industries",
    "industries": "Industries",
    "description": "Description",
    "primary_location": "Primary Location",
    "phone": "Phone",
    "emails": "Emails",
    "domains": "Domain(s)",
    "website": "Website",
    "employees": "Employees",
    "linkedin": "LinkedIn",
    "twitter": "Twitter"
  },
  "company_actions": {
    "add_location": "Add Location",
    "set_location": "Set Location",
    "view_all": "View All",
    "create_note": "Create Note",
    "create_opportunity": "Create Opportunity",
    "log_new_activity": "Log New Activity",
    "add_to_list": "Add to list",
    "add_company": "Add company \"{{companyName}}\"",
    "update_company_logo": "Update company logo",
    "edit_company_details": "Edit company details",
    "edit_address_details": "Edit address details",
    "report_incorrect_info": "Report Incorrect Info",
    "audit_trail": "Audit Trail",
    "referred_by": "Referred by",
    "archive_company": "Archive Company"
  },
  "notes": {
    "empty_state": "There's no note on this contact yet"
  },
  "cleaner": {
    "company": {
      "incomplete": {
        "title": "Incomplete",
        "description": "These companies have incomplete data such as location, industry and type."
      },
      "duplicate": {
        "title": "Duplicates",
        "description": "These companies have similar domain names. You can merge the companies or keep them separate.",
        "warning": "Merging companies cannot be undone.",
        "merge_details": "When merging, we will combine both companies' contacts and interactions. Any notes, tasks, and documents other than those of main company will be permanently removed."
      },
      "archived": {
        "title": "Archived",
        "description": "These contacts or companies have been removed from the active database"
      }
    },
    "contact": {
      "incomplete": {
        "title": "Incomplete Contacts",
        "description": "These contacts have incomplete data such as name, role and location."
      },
      "duplicate": {
        "title": "Duplicates",
        "description": "These contacts have the same information such as name. To combine contact, please indicate if these contacts are the same or unique."
      },
      "unengaged": {
        "title": "Unengaged",
        "description": "These contacts have not interacted with your company for some time. Reactivate unengaged contacts with an email or meeting."
      },
      "bounced": {
        "title": "Bounced",
        "description": "Emails of these contacts recently bounced. Please edit the email to the correct address or archive contact to be removed from the lists."
      }
    },
    "tabs": {
      "company": "Company",
      "contact": "Contact"
    }
  },
  "contact_management": {
    "update": {
      "email": {
        "title": "Update Email",
        "modal_header": "Update Contact Email"
      }
    },
    "bounced": {
      "table": {
        "headers": {
          "contact": "Contact",
          "company": "Company",
          "last_interaction": "Last Interaction",
          "created_at": "Created At",
          "actions": "Actions"
        }
      },
      "actions": {
        "remove_status": "remove bounced status",
        "unbounce": {
          "confirmation_title": "Remove Bounced Status",
          "confirmation_content": "Mark email as not bounced?"
        }
      }
    },
    "privacy": {
      "set_public": {
        "title": "Set Contact as Public",
        "content": "Any future interactions between you and this contact will be tracked. Past interactions when the contact was set as private will not appear."
      },
      "set_private": {
        "title": "Set Contact as Private",
        "content": "Any future interactions (e.g. activity feed, who knows) that include you and this contact will not be tracked.",
        "delete_past_interactions": "Delete past interactions between you and this contact."
      },
      "action_text": "Set Contact as {{status}}"
    },
    "ignore": {
      "single": {
        "confirmation_title": "Ignore Contact?",
        "confirmation_content": "This action will permanently remove the contact from this list."
      },
      "bulk": {
        "confirmation_title": "Bulk Ignore Contacts?",
        "confirmation_content": "This action will permanently remove the contacts from this list."
      }
    },
    "hierarchy": {
      "move": {
        "button_text": "Move Contact",
        "modal_title": "Move Contact to Hierarchy",
        "company_label": "Company",
        "company_placeholder": "Which company do you want to move the contact to",
        "validation": {
          "company_required": "Please select a company"
        }
      }
    },
    "marketing": {
      "allowance": {
        "description": "Count of unique contacts we have sent from Campaigns per month",
        "table": {
          "headers": {
            "month": "Month",
            "contacts_count": "Contacts Count",
            "allowance": "Allowance",
            "utilisation": "Utilisation"
          }
        }
      }
    }
  },
  "company": {
    "activity_history": {
      "view_all_bd_activities": "View all BD activities",
      "bd_lead_marketing_activities": "BD & Lead & Marketing Activities"
    },
    "meeting_history": {
      "view_meeting_history": "View meeting history",
      "meeting_history_title": "Meeting History"
    }
  },
  "move_to_company": {
    "button": "Move to Company",
    "company_label": "Company",
    "move_contact_button": "Move contact"
  },
  "unengaged": {
    "table": {
      "headers": {
        "contact": "Contact",
        "company": "Company",
        "last_interaction": "Last Interaction",
        "action": "Action"
      }
    },
    "actions": {
      "archive_contact": "archive contact",
      "add_to_list": "Add to list"
    },
    "order_by": {
      "label": "Order by"
    }
  },
  "email_management": {
    "modals": {
      "add_personal_email": "Add Personal Email",
      "add_company_email": "Add Company Email",
      "add_new_contact": "Add new Contact to Person"
    },
    "fields": {
      "new_work_email": "New work email",
      "email_address": "Email Address",
      "enter_email_placeholder": "Enter email address"
    },
    "actions": {
      "add_email": "Add Email"
    },
    "validation": {
      "enter_valid_email": "Please enter a valid email to create contact",
      "start_typing_search": "start typing to search for contact",
      "create_contact": "Create contact \"{{email}}\"",
      "error_validating_email": "There was an error validating the email.",
      "use_valid_email": "Please use a valid email address."
    },
    "duplicates": {
      "review_duplicates": "Review Potential Duplicates",
      "potential_duplicate_detected": "Potential Duplicate Person Detected"
    }
  },
  "classified": {
    "private_contact": "Private contact"
  },
  "export": {
    "export_contacts": "Export Contacts"
  },
  "person_profile": {
    "actions": {
      "archive_person": "Archive Person",
      "edit_details": "Edit details",
      "update_contact": "Update contact"
    },
    "tabs": {
      "details": "Details",
      "experience": "Experience",
      "education": "Education",
      "skills_and_interest": "Skills and Interest"
    },
    "details": {
      "first_name_last_name": "First Name / Last Name",
      "personal_address": "Personal Address",
      "phone_numbers": "Phone Numbers",
      "links": "Links"
    },
    "forms": {
      "first_name": "First Name",
      "last_name": "Last Name",
      "phone_number": "Phone Number",
      "physical_address": "Physical Address",
      "social_media": "Social Media",
      "linkedin": "LinkedIn",
      "twitter": "Twitter",
      "linkedin_url": "LinkedIn Url",
      "twitter_url": "Twitter Url",
      "personal_information": "Personal Information",
      "changes_saved": "Changes Saved!",
      "error_submitting": "An error occurred while submitting the form.",
      "search_address": "Search for an address"
    },
    "contacts": {
      "title": "Contacts",
      "description": "A person can have multiple contacts, each showing a different association or affiliation—such as with a company or a personal email",
      "link": "Link"
    },
    "experience": {
      "loading": "Loading experience..."
    },
    "empty_state": {
      "nothing_to_show": "Nothing to show here yet",
      "click_edit_details": "Click Edit details to add Person Information"
    }
  },
  "career_companies": {
    "modal": {
      "create_title": "Create New Experience",
      "edit_title": "Edit Experience"
    },
    "actions": {
      "add_experience": "Add Experience"
    },
    "form": {
      "labels": {
        "company": "Company",
        "company_name": "Company Name",
        "job_title": "Job Title",
        "start_date": "Start Date",
        "end_date": "End Date"
      },
      "placeholders": {
        "search_company": "Type to search company"
      },
      "validation": {
        "job_title_required": "Please enter a job title",
        "start_date_required": "Please enter a start date",
        "end_date_required": "Please enter an end date"
      }
    },
    "sections": {
      "companies_title": "Companies"
    }
  },
  "states": {
    "messages": {
      "no_data_source": "No data source provided.",
      "no_table_definition": "No table definition provided."
    }
  },
  "filters": {
    "date": {
      "equals": "Equals",
      "not_equal": "Does Not Equal",
      "before": "Before",
      "after": "After",
      "between": "Between"
    }
  }
}
